import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'rms-plan-completion',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './rms-plan-completion.component.html',
  styleUrl: './rms-plan-completion.component.css'
})
export class RmsPlanCompletionComponent implements OnInit, OnChanges {

  @Input() rmsPlanSummaryData: any;
  @Output() onSaveSection1 = new EventEmitter<any>();
  
    yesNo = EYesNo;
    planCompletionForm: FormGroup = new FormGroup([]);
  
    constructor(
      // private cdr: ChangeDetectorRef
    ) { }
  
    ngOnInit() {
      this.initializeForm();
    }
  
    ngOnChanges(changes: SimpleChanges) {
      if (changes['rmsPlanSummaryData'] && changes['rmsPlanSummaryData'].currentValue) {
        this.initializeForm();
      }
    }
  
    private initializeForm() {
      let group: any = {};
      const defaultValue = this.rmsPlanSummaryData && this.rmsPlanSummaryData.certification !== undefined
                        ? this.rmsPlanSummaryData.certification
                        : this.yesNo.Yes;
      group['certification'] = new FormControl(String(defaultValue), Validators.required);
      group['rms_plan_notes'] = new FormControl(this.rmsPlanSummaryData?.rms_plan_notes || '', Validators.required);
      this.planCompletionForm = new FormGroup(group);
    }
  
    saveRmsPlanCompletion(): void {
      if (this.planCompletionForm.valid) {
        this.onSaveSection1.emit(this.planCompletionForm.value);
      }
    }

}
